/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Trackermodal_Popupblocked2Inputs */

const he_extension_trackermodal_popupblocked2 = /** @type {(inputs: Extension_Trackermodal_Popupblocked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חלון ההתחברות נחסם. יש לאפשר חלונות קופצים באתר זה, או לפתוח את דף ההתחברות בלשונית חדשה.`)
};

const en_extension_trackermodal_popupblocked2 = /** @type {(inputs: Extension_Trackermodal_Popupblocked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in popup was blocked. Please allow popups for this site, or open the sign-in page in a new tab.`)
};

/**
* | output |
* | --- |
* | "Sign-in popup was blocked. Please allow popups for this site, or open the sign-in page in a new tab." |
*
* @param {Extension_Trackermodal_Popupblocked2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_trackermodal_popupblocked2 = /** @type {((inputs?: Extension_Trackermodal_Popupblocked2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Trackermodal_Popupblocked2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_trackermodal_popupblocked2(inputs)
	return en_extension_trackermodal_popupblocked2(inputs)
});
export { extension_trackermodal_popupblocked2 as "extension_trackerModal_popupBlocked" }